<template>
  <div id="app" ref="app">
    <div class="toptop">
      <span
        >可语音讲解，可加/减页面，包运行，包改错，接各种项目，包至上线前或交作业前，价格公道！！</span
      >
      <span>程序小哥全天在线,需要什么项目可直接加好友联系本人</span>
    </div>
    <div class="top">
      <div class="search">
        <a href="javascript:;" class="logo" @click="goHome">
          <img src="./assets/logo.png" alt="" />
        </a>
        <el-input
          v-model="inputKey"
          type="search"
          placeholder="请输入搜索关键字"
          @search.native="search"
        >
          <i
            slot="suffix"
            class="el-input__icon el-icon-search"
            @click="search"
          ></i>
        </el-input>
      </div>
      <div class="nav">
        <div class="logoo">
          <router-link to="/Home" active-class="active"
            ><span>首页</span></router-link
          >
          <router-link to="/VueNode" active-class="active"
            ><span>vue+node</span></router-link
          >
          <router-link to="/VueSB" active-class="active"
            ><span>vue+SpringBoot</span></router-link
          >
          <router-link to="/HomeWork" active-class="active"
            ><span>普通作业</span></router-link
          >
          <router-link to="/WxApp" active-class="active"
            ><span>微信小程序</span></router-link
          >
        </div>
      </div>
    </div>
    <div class="main">
      <div class="" :class="isDark === true ? 'Dark view' : 'view'">
        <router-view></router-view>
        <div class="Hot" v-if="this.$route.path !== '/Home'">
          <div class="title"><span>本周热门</span></div>
          <div class="Hot_bottom">
            <ul>
              <li>
                <a href="javascript:;"><span>1</span>疫情打卡</a>
              </li>
              <li>
                <a href="javascript:;"
                  ><span style="background-color: #ffc107">2</span>西航商城</a
                >
              </li>
              <li>
                <a href="javascript:;"
                  ><span style="background-color: #03a9f4">3</span>校园月老</a
                >
              </li>
              <li>
                <a href="javascript:;"
                  ><span style="background-color: #4caf50">4</span>鲜花售卖</a
                >
              </li>
              <li>
                <a href="javascript:;"
                  ><span style="background-color: #55efc4">5</span>毛绒玩具售卖
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <BeiAn></BeiAn>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      isDark: false,
      inputKey: "",
    };
  },
  components: {},
  beforeMount() {
    this.$bus.$on("theme-change", (val) => {
      if (val === "dark") {
        this.isDark = true;
        document.querySelector("body").setAttribute("class", "dark-theme");
      } else {
        this.isDark = false;
        document.querySelector("body").setAttribute("class", "");
      }
    });
    localStorage.getItem("theme") === "dark"
      ? (this.isDark = true)
      : (this.isDark = false);
  },
  watch: {},

  created() {
    axios.get("./data/myData.json").then((result) => {
      this.$store.dispatch("putData", result.data);
    });
  },
  methods: {
    goHome() {
      this.$router.push("/Home");
    },
    search() {
      this.$router.push({
        path: "/Search",
        query: {
          key: this.inputKey,
        },
      });
      this.inputKey = "";
    },
  },
  mounted() {},
};
</script>
<style lang="less">
* {
  margin: 0;
  padding: 0;
  color: #333;
  box-sizing: border-box;
}
ul,
ol {
  margin: 0;
  padding: 0;
  list-style: none;
}
a {
  color: #333;
  text-decoration: none;
}
.title {
  cursor: pointer;
}
.dark-theme {
  background-color: #292a2d !important;
  transition: color 0.2s ease, border-color 0.2s ease, background 0.2s ease,
    opacity 0.2s ease;
  .nickname,
  small {
    color: #a9a9b3 !important;
  }
  .zuobiao {
    span {
      color: #a9a9b3 !important;
    }
  }
  .description {
    p {
      color: #a9a9b3 !important;
    }
  }
}

.Dark {
  .VueNode ul li {
    background-color: #292a2d !important;
    p {
      border: none;
    }
    span {
      color: #eee !important;
    }
  }
  .Hot {
    border: 1px solid #eee;
    background-color: #292a2d !important;
    span {
      color: #eee;
    }
    .Hot_bottom {
      ul {
        li {
          a {
            color: #eee !important;
          }
        }
      }
    }
  }
  .detail {
    background-color: #292a2d !important;
    border: 1px solid #eee;
    h1 {
      color: #eee;
    }
  }
}
.toptop {
  height: 40px;
  padding: 0 74.5px;
  display: flex;
  justify-content: space-between;
  span {
    display: block;
    color: #fff;
    font-size: 15px;
    line-height: 40px;
  }
  background-image: linear-gradient(90deg, #f97794 0, #8360bc 100%);
}
.search {
  width: 90%;
  margin: 0 auto;
  display: flex;
  height: 80px;
  justify-content: space-between;
  align-items: center;
  .logo {
    height: 50px;
    width: 100px;
    border-radius: 15px;
    overflow: hidden;
    img {
      width: 100%;
      margin-top: -25%;
    }
  }
  .el-input {
    width: 300px;
    input {
      border-radius: 15px;
    }
    & input:focus {
      border: 1px solid #ff4d4f !important;
    }
    .el-icon-search {
      font-size: 30px !important;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      color: #ff4d4f;
    }
  }
}
.nav {
  background-color: #fff;
  height: 50px;
  display: flex;
  box-shadow: 2px 2px 10px 1px rgba(0, 0, 0, 0.2);

  .logoo {
    display: flex;
    justify-content: space-around;
    flex: 1;
    a {
      height: 50px;
      line-height: 50px;
      box-sizing: border-box;
      padding: 0 10px;
      transition: all 0.1s;
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        font-size: 15px;
      }
    }
  }
}
.main {
  width: 90%;
  margin: 0 auto;
}
.view {
  width: 100%;
  margin: 10px auto 0;
  display: flex;
  .VueNode {
    flex: 3;
  }
  .Hot {
    height: 300px;
    background-color: #fff;
    padding: 10px 10px;
    margin-left: 10px;
    flex: 1;
    width: 300px;
    display: flex;
    flex-direction: column;
    .title {
      padding-left: 5px;
      border-radius: 2px;
      border-left: 3px solid #ff4d4f;
    }
    .Hot_bottom {
      font-size: 20px;
      li {
        display: flex;
        margin-top: 10px;
        font-size: 15px;
        display: flex;
        line-height: 25px;
        align-items: center;
        a {
          display: flex;
          width: 100%;

          & span:nth-child(1) {
            height: 25px;
            width: 35px;
            font-size: 17px;
            color: #fff;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: #ff2a2a;
            border-radius: 5px;
            margin-right: 15px;
          }
        }
        & a:hover {
          color: #999;
        }
      }
    }
  }
}
// 手机端
@media screen and(max-width: 750px) {
  body {
    #app {
      .main {
        width: 100%;
      }
      .search {
        width: 100% !important;
        .el-input {
          height: 50px;
          input {
            height: 50px;
            background-color: #f3f3f3;
          }
        }
      }
      .footer {
        display: none;
      }
      .view {
        width: 750px !important;
        .li_right {
          .el-button {
            display: none;
          }
        }
      }
      .toptop {
        display: none;
      }
      .Hot {
        display: none !important;
      }
      .active {
        background-color: #62c372 !important;
        span {
          color: #fff !important;
        }
      }
      .lunbotu .el-carousel .el-carousel__arrow {
        display: none !important;
      }
      .nav {
        height: 60px !important;
        align-items: center;
      }
      .nav a {
        background-color: #eee;
        border-radius: 10px;
        height: 40px !important;
        line-height: 40px !important;
      }
    }
  }
}
// 电脑端
@media screen and(min-width: 751px) {
  body {
    overflow-x: hidden;
    overflow-y: scroll;
    width: 100%;
    background-color: #f3f3f3;
    #app {
      .top {
        background-color: #fff;
      }
      .active {
        border-bottom: 3px solid #ff4d4f !important;
      }
      .lunbotu .el-carousel .el-carousel__arrow {
        display: block !important;
      }
      .nav a {
        background-color: #fff;
        border-radius: 0;

        &:hover {
          border-bottom: 3px solid #333;
        }
      }
    }
  }
}
</style>
